/**
 * React Router Configuration
 * 
 * 簡化為單頁應用路由
 * Requirements: 技術架構 - 純前端應用
 */

import { createBrowserRouter } from 'react-router-dom'
import App from './App'

export const router = createBrowserRouter([
  // 主頁 - MJJ 交易工具
  {
    path: '/',
    element: <App />,
  },
  // 所有其他路徑重定向到主頁
  {
    path: '*',
    element: <App />,
  },
])
